import { addCookieListener } from '@/lego/utils/navigator/cookies';

export default function boot(app) {
  // Google Tag Manager
  addCookieListener('cookies_accept_analytics', function() {
    // Dependencias de Google.
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-W2C5KKD');
  })
    // Google Tag Manager cargado con éxito.
    .then(function() {
      console.log('¡Dependencias de Google cargadas!');
    })

    // Error al cargar Google Tag Manager.
    .catch(function(error) {
      console.error('Ha ocurrido un error:');
      console.error(error);
    });
  // End Google Tag Manager

  //<script src="https://maps.googleapis.com/maps/api/js?key={{ config('services.google.places_api_key') }}&region=SP&language=sp&libraries=places"></script>;

  // Google Analytics
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'js': new Date(),
      'config': i,
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtag/js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'G-JGKP67F45N');

  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  gtag('consent', 'default', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
    'functionality_storage': 'granted',
    'personalization_storage': 'denied',
    'security_storage': 'granted',
  });

  function updateAdStorage() {
    gtag('consent', 'update', {
      'ad_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted',
      'personalization_storage': 'granted',
    });
  }

  function updateAnalyticsStorage() {
    gtag('consent', 'update', {
      'analytics_storage': 'granted',
    });
  }

  addCookieListener('cookies_accept_analytics', function() {
    updateAnalyticsStorage();
  });

  addCookieListener('cookies_accept_marketing', function() {
    updateAdStorage();
  });
  // End Google Analytics
}
